import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CAMPAIGN_VIDEO_REPORT_ID = `campaign${VIDEO_CAMPAIGN_SUFFIX}`;
